
<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="invexpmate"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmarinvexpmate" title="Pregunta" appendTo="body"></p-confirmDialog>
<div class="p-grid" style="width: 98%">
	<div class="p-col-12">
		<app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonRegresar]="btnRegresar"
                         [botonBorrar]="btnBorrar"
                       	[barraExpMate]="false" 
						 (signal)="manejarSenales($event)" 
						  [botonBuscarPermanente]="btnBuscar"
						  [barraBotones3]="true"
						  [barraBotonesDesplaz]="true"
						  [botonBinocular]="true"
						  [botonImprimir]="true"
						  
						  [barraBotones5]="true" [botonVisto]="false" [barraBotonesCRUD]="false" [barraBotones3Alt]="false"
						  >
		</app-invmaebarra>
	</div>
</div>

<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
	<p-tabPanel header="Cobertura">
		<p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
			<div class="contorno" id="contorno">
				<div class="divgrups">
					<div class="p-grid">
						<!--LINEA 1-->
						<div class="p-col-1">
							<span>Código:</span>
						</div>
						<div class="p-col-2">
							<label for="ENCEXPMAT_CODIGO"></label>
							<input class="frm" id="ENCEXPMAT_CODIGO" type="text" pInputText disabled
								[(ngModel)]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_CODIGO"
								(keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()" autocomplete="off">
						</div>
						<!-- LINEA2 -->
						<div class="p-col-12" style="margin-top: -7px">
							<div class="p-grid">
								<div class="p-col-1">
									<span>Cobertura:</span>
								</div>
								<div class="p-col-2">
									<label for="ENCEXPMAT_COBERTURA"></label>
									<input class="frm" id="ENCEXPMAT_COBERTURA" type="text" pInputText oninput="this.value= this.value.replace(/[^0-9]/g, '');"
										[disabled]="false"
										[(ngModel)]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_COBERTURA"
										(keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
										autocomplete="off">
								</div>
								<div class="p-col-1">
									<span>Desde: </span>
								</div>
								<div class="p-col-1">
									<p-calendar id="ENCEXPMAT_FECHAINI" [inputStyle]="{width: '100%', height: '20px'}"
										[(ngModel)]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_FECHAINI"
										[readonlyInput]="true" dateFormat="dd/mm/yy" 
										[disabled]="boolfechadesde"
										(onSelect)="calcularPerdesde($event)"
										>
									</p-calendar>
								</div>
								<div class="p-col-1">
									<span>Periodo: </span>
								</div>
								<div class="p-col-2">
									<label for="ENCEXPMAT_PERIODO"></label>
									<input class="frm" id="ENCEXPMAT_PERIODO" type="text" pInputText oninput="this.value= this.value.replace(/[^0-9]/g, '');"
										[(ngModel)]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_PERIODO"
										[disabled]="!boolfechadesde"
										(keydown.enter)="calfechadesde()" (keydown)="botonesmodificar()" autocomplete="off">
								</div>
								<div class="p-col-1">
									<span>Días: </span>
								</div>
								<div class="p-col-2">
									<p-checkbox id="chkdias" name="chkdias" value="" label=""
										binary="{{chkdias}}" [(ngModel)]="chkdias"
										(click)="botonesmodificar()" (keydown.enter)="setFocus($event)"
										(onChange)="cambioDias($event)"></p-checkbox>
								</div>
							</div>
						</div>
						<!-- LINEA3 -->
						<div class="p-col-12" style="margin-top: -7px">
							<div class="p-grid">
								<div class="p-col-3"></div>
								<div class="p-col-1">
									<span>Hasta: </span>
								</div>
								<div class="p-col-1">
									<p-calendar id="ENCEXPMAT_FECHAFIN" [inputStyle]="{width: '100%', height: '20px'}"
										[(ngModel)]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_FECHAFIN"
										[readonlyInput]="false" dateFormat="dd/mm/yy" 
										 dateFormat="dd/mm/yy" 
										(keydown)="botonesmodificar()"
										[disabled]="false">
									</p-calendar>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="divg" style="height: 650px">
			<app-aggridsaci  [width]="" [height]="largo" [enableSorting]="false"
				[enableFilter]="true" [rowData]="invexpmaterialesService.detexpmatearray[indicador]"
				[frameworkComponents]="frameworkComponents" [animateRows]="true" [rowSelection]="rowSelection"
				[columnDefs]="columnDefsDetexpmate" [defaultColDef]="defaultColDef" [rowStyle]="rowStyle"
				[singleClickEdit]="false" [botones]="true" [botonNuevo]='bolNuevodet' (selected)="selecciondetexpmate($event)"
				[mostrarGuardar]="false" [botonesAdicionales]="false" 
				(cambios)="cambio($event)"
				[CC]="true"
				></app-aggridsaci>
			</div>
		</p-scrollPanel>
	</p-tabPanel>

	<p-tabPanel header="Explosion de materiales MP" [disabled]="disablebooltabs">
		
			<app-aggridsaci [width]="" [height]="70" [enableSorting]="false" [enableFilter]="true"
			[rowData]="invexpmaterialesService.trnexpmatmp" [frameworkComponents]="frameworkComponents" [animateRows]="true"
			[rowSelection]="rowSelection" [columnDefs]="columnDefsDetexpmateMP" [defaultColDef]="defaultColDefmp"
			[rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true" (selected)="seleccionexpmatemp($event)"
			[CC]="true"></app-aggridsaci>
		
		
	
	</p-tabPanel>
	<p-tabPanel header="Explosion de materiales AC" [disabled]="disablebooltabs">
		
			<app-aggridsaci [width]="" [height]="70" [enableSorting]="false" [enableFilter]="true"
			[rowData]="invexpmaterialesService.trnexpmatac" [frameworkComponents]="frameworkComponents" [animateRows]="true"
			[rowSelection]="rowSelection" [columnDefs]="columnDefsDetexpmateAC" [defaultColDef]="defaultColDefac"
			[rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true" (selected)="seleccionexpmateac($event)"
			[CC]="true">
		</app-aggridsaci>
		
	</p-tabPanel>
</p-tabView>

<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
	<p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
	</p-progressSpinner>
	<p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true"  [closable]="false"
	[style]="{ opacity: 0.00}" position="top">
	</p-dialog>	
</div>
<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>
<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '40vw', height: '400px'}">
	<app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
		[strNumDoc]="invexpmaterialesService.encexpmate[indicador].ENCEXPMAT_CODIGO" [strCampo]="'ENCEXPMAT_CODIGO'"
		[botonExcel]="true"
		(cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>